import type { ReactNode } from 'react';
import { RecordPicker } from '../../components/RecordPicker.js';

interface RuleOption {
  readonly ruleId: string;
  readonly ruleCode: string;
  readonly ruleName: string;
}

interface Props {
  readonly label: string;
  readonly value: string;
  readonly onPick: (ruleId: string, label: string) => void;
}

/** A business rule, picked by its code and name. */
export function RulePicker({ label, value, onPick }: Props): ReactNode {
  return (
    <RecordPicker<RuleOption>
      endpoint="/v1/rules?limit=200"
      idField="ruleId"
      label={label}
      testId="ruleId"
      value={value}
      optionLabel={(r) => `${r.ruleCode} \u2014 ${r.ruleName}`}
      onPick={onPick}
    />
  );
}
